import React, { useState, useEffect } from "react";

import { Link } from 'react-router-dom'
import Header from "../../Components/Header";
import UniversalBanner from "../../Components/UniversalBanner";
import Footer from "../../Components/Footer";
import { UniversalImg2 } from "../../Constant/Index";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const ContactUs = () => {

    const [startDate, setStartDate] = useState("");
    useEffect(() => {
        const inputElement = document.getElementById('myInput');

        const changePlaceholder = () => {
            if (inputElement) {
                inputElement.placeholder = 'Date of Birth';
            }
        };

        const timeoutId = setTimeout(changePlaceholder, 1000);

        return () => {
            clearTimeout(timeoutId);
        };
    }, []);
    return (
        <>
            <Header />
            <UniversalBanner heading="Contact Us" />
            <section className="auth-section">
                <div className="container">
                    <div className="auth-start">
                        <div className="row">
                            <div className="col-md-7 order-1 order-md-0 mt-5 mt-md-0">
                                <div className="row">
                                    <div className="col-xl-1"></div>
                                    <div className="col-xl-10 col-lg-11">
                                        <div className="form-area" data-aos="fade-left" data-aos-duration="800">
                                            <h2 className="md-heading mb-lg-5 mb-4">Whats on your mind</h2>
                                            <form action="">
                                                <div className="row">
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                        <div className="form-group">
                                                            <input type="text" name="" id="" className="form-control" placeholder="First Name" />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                        <div className="form-group">
                                                            <input type="text" name="" id="" className="form-control" placeholder="Last Name" />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-4 col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                        <div className="form-group position-relative password">
                                                            {/* <input type="text" name="" id="" className="form-control" placeholder="Date OF Birth" /> */}
                                                            <DatePicker selected={startDate} placeholder="Date OF Birth" id="myInput" className="form-control" onChange={(date) => setStartDate(date)} />
                                                            <button className="show-password" type="button">
                                                                <svg width="16" height="18" viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                                    <path d="M4.88889 1V3.4M11.1111 1V3.4M1.38889 6.672H14.6111M15 6.2V13C15 15.4 13.8333 17 11.1111 17H4.88889C2.16667 17 1 15.4 1 13V6.2C1 3.8 2.16667 2.2 4.88889 2.2H11.1111C13.8333 2.2 15 3.8 15 6.2Z" stroke="#8A8888" stroke-width="1.5" stroke-miterlimit="10" stroke-linecap="round" stroke-linejoin="round" />
                                                                    <path d="M10.9927 11H11M10.9927 13H11M7.99676 11H8.00486M7.99676 13H8.00486M5 11H5.0081M5 13H5.0081" stroke="#8A8888" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
                                                                </svg>
                                                            </button>
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12"></div>
                                                    <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                        <div className="form-group">
                                                            <input type="text" name="" id="" className="form-control" placeholder="Enter Email" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-6 col-sm-6 mb-3 mb-md-3 mb-lg-4">
                                                        <div className="form-group">
                                                            <input type="text" name="" id="" className="form-control" placeholder="Enter Contact" />
                                                        </div>
                                                    </div>
                                                    <div className="col-md-12 mb-3 mb-md-3 mb-lg-4">
                                                        <div className="form-group">
                                                            {/* <input type="text" name="" id="" className="form-control" placeholder="Enter Contact" /> */}
                                                            <textarea name="" id="" cols="30" rows="10" className="form-control textarea-sm" placeholder="Message"></textarea>
                                                        </div>
                                                    </div>

                                                    <div className="col-md-12 mb-4">
                                                        <div className="form-submit">
                                                            <button type="submit" className="btn d-block px-5">Submit</button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-5 col-md-5">
                                <figure className="with-bg with-hover"  data-aos="fade-right" data-aos-duration="800">
                                    <img src={UniversalImg2} className="auth-img w-100 with-boxes with-raduis" alt="" />
                                </figure>
                            </div>
                        </div>
                    </div>
                </div>
            </section >
            <Footer />
        </>
    )
}
export default ContactUs;